import { cardAt, isMonsterZone, isSpellZone, num } from './_shared';

/**
 * **表示形式の変更**（Issue #589）。
 *
 * | variant | 意味 |
 * |---|---|
 * | `flip` | 裏 ↔ 表（モンスター。表 → 裏も同じ＝分けない。ユーザー 2026-09-28） |
 * | `turn` | 表のまま攻 ↔ 守 |
 * | `spell` | 魔法・罠の表裏（向きは無い） |
 *
 * 事実: `who`（変わったあとの姿。ATK / DEF・レベルは盤面の今の値）/ `panel`（ステータスのパネルを出してよいか
 * ＝ ダメージステップの間に効果の処理でなく変わったときだけ false。魔法・罠は常に false）。
 * 何も変わっていなければ null（出さない）
 */
export const VARIANTS = Object.freeze([
  { name: 'flip', label: '裏 ↔ 表（モンスター）' },
  { name: 'turn', label: '攻 ↔ 守' },
  { name: 'spell', label: '魔法・罠の表裏' },
]);

/** ダメージステップの間に効果の処理でなく変わったときだけパネルを出さない（窓はそのステップ / そのチェーンのリンク） */
export function showsPanel(history) {
  const inDamageStep = history?.last?.('damage_step_start', { until: ['damage_step_end', 'new_phase', 'new_turn'] });
  if (!inDamageStep) return true;
  const inEffect = history?.last?.('chain_solving', { until: ['chain_solved', 'chain_end', 'new_phase', 'new_turn'] });
  return Boolean(inEffect);
}

export default Object.freeze({
  event: 'pos_change',
  variants: VARIANTS,
  classify({ payload, board, history }) {
    const { uid } = payload ?? {};
    const prev = payload?.prevPosition;
    const next = payload?.position;
    const spell = isSpellZone(payload?.zone);
    if (!uid || !(isMonsterZone(payload?.zone) || spell) || !prev || !next) return null;
    if (prev.faceUp === next.faceUp && (spell || prev.defense === next.defense)) return null;
    const variant = spell ? 'spell' : (prev.faceUp !== next.faceUp ? 'flip' : 'turn');
    const c = cardAt(board, uid, payload.zone);
    const st = c?.stats ?? null;
    return {
      ...payload,
      variant,
      /** 動きの種類（裏表が変わる = `flip` / 表のまま向きだけ = `turn`。魔法・罠は `flip`） */
      motion: variant === 'turn' ? 'turn' : 'flip',
      spell,
      panel: spell ? false : showsPanel(history),
      who: {
        uid,
        zone: payload.zone,
        code: c?.code ?? payload.code ?? null,
        faceUp: Boolean(next.faceUp),
        defense: Boolean(next.defense),
        atk: num(st?.atk ?? st?.attack),
        def: num(st?.def ?? st?.defense),
        level: num(st?.level),
        baseAtk: num(st?.base_atk),
        baseDef: num(st?.base_def),
      },
    };
  },
});
